import { withPlugins, eventBus, domEvents, device } from '@spon/plugins';
import Headroom from 'headroom.js';
import toggle from '@/ui/toggle';

function Header({ node, name, plugins: { addEvents, device } }) {
	if (!node) return;

	// Prevent multiple initializations
	if (node.dataset.headerInitialized) return;
	node.dataset.headerInitialized = 'true';

	/*
	 *		Variables
	 */
	const menuTriggers = node.querySelectorAll('[data-menu-trigger]');
	const mobileMenuTriggers = node.querySelectorAll(
		'[data-mobile-menu-trigger]'
	);
	const mobileSubMenuTriggers = node.querySelectorAll(
		'[data-mobile-sub-menu-trigger]'
	);
	const mobileMenuBackButtons = node.querySelectorAll(
		'[data-mobile-menu-back]'
	);
	const mobileSubMenuBackButtons = node.querySelectorAll(
		'[data-mobile-sub-menu-back]'
	);
	const mobileMenuCloseButton = node.querySelectorAll(
		'[data-mobile-menu-close]'
	);
	const menuTargets = node.querySelectorAll('[data-menu-target]');
	const mobileMenuTargets = node.querySelectorAll('[data-mobile-menu-target]');
	const mobileSubMenuTargets = node.querySelectorAll(
		'[data-mobile-sub-menu-target]'
	);
	const $experienceMenuList = node.querySelector('#menu-list-experiences');
	const $holidayIdeasList = node.querySelector('#menu-list-holiday-ideas');

	// Search Elements
	const $searchControl = node.querySelector(
		'.search-control input[type="search"]'
	);
	const $searchClose = node.querySelector('[data-search-close]');
	const $headerSearchWrapper = node.querySelector('.header__search-wrapper');

	// Search input
	// const searchInput = node.querySelector('.header-search__input');

	// const desktopSubMenu = node.querySelector('#desktop-sub-menu');

	menuTriggers.forEach(trigger => {
		const target = trigger.dataset.menuTrigger;
		const targetElement = node.querySelector(`[data-menu-target="${target}"]`);

		const openMenu = () => {
			menuTargets.forEach(t => {
				t.classList.remove('is-open');
			});
			menuTriggers.forEach(t => {
				const triggerBtn = t.querySelector(':scope > a, :scope > button');
				if (triggerBtn) {
					triggerBtn.setAttribute('aria-expanded', 'false');
				}
			});

			if (targetElement) {
				targetElement.classList.add('is-open');
				const triggerBtn = trigger.querySelector(':scope > a, :scope > button');
				if (triggerBtn) {
					triggerBtn.setAttribute('aria-expanded', 'true');
				}
			}
		};

		let closeTimer = null;

		const scheduleClose = () => {
			closeTimer = setTimeout(() => {
				if (targetElement) {
					const activeEl = document.activeElement;
					if (trigger.contains(activeEl)) {
						return;
					}
					targetElement.classList.remove('is-open');
					const triggerBtn = trigger.querySelector(
						':scope > a, :scope > button'
					);
					if (triggerBtn) {
						triggerBtn.setAttribute('aria-expanded', 'false');
					}
				}
			}, 150);
		};

		const cancelClose = () => {
			if (closeTimer) clearTimeout(closeTimer);
		};

		// Panel is now inside the <li>, so mouseenter/mouseleave on the
		// trigger <li> covers both trigger text and panel area.
		trigger.addEventListener('mouseenter', () => {
			cancelClose();
			openMenu();
		});
		trigger.addEventListener('mouseleave', scheduleClose);

		// Keep focusin/focusout for keyboard navigation
		trigger.addEventListener('focusin', () => {
			cancelClose();
			openMenu();
		});
		trigger.addEventListener('focusout', scheduleClose);
	});

	// Search input
	// searchInput.addEventListener('keyup', () => {
	// 	if (searchInput.value.length === 0 || searchInput.value === '') {
	// 		node.classList.remove('has-search-value');
	// 	} else {
	// 		node.classList.add('has-search-value');
	// 	}
	// });

	// Close desktop menus when clicking outside
	document.addEventListener('click', e => {
		if (
			!e.target.closest('[data-menu-trigger]') &&
			!e.target.closest('[data-menu-target]')
		) {
			menuTargets.forEach(target => {
				target.classList.remove('is-open');
			});
		}
	});

	mobileMenuTriggers.forEach(trigger => {
		trigger.addEventListener('click', e => {
			e.preventDefault();
			const target = trigger.dataset.mobileMenuTrigger;
			const targetElement = node.querySelector(
				`[data-mobile-menu-target="${target}"]`
			);
			targetElement.classList.add('is-open');
			trigger.setAttribute('aria-expanded', 'true');
		});
	});

	mobileSubMenuTriggers.forEach(trigger => {
		trigger.addEventListener('click', e => {
			e.preventDefault();
			const target = trigger.dataset.mobileSubMenuTrigger;
			const targetElement = node.querySelector(
				`[data-mobile-sub-menu-target="${target}"]`
			);
			targetElement.classList.add('is-open');
			trigger.setAttribute('aria-expanded', 'true');
		});
	});

	// Mobile menu back buttons
	mobileMenuBackButtons.forEach(button => {
		button.addEventListener('click', e => {
			e.preventDefault();
			const target = button.dataset.mobileMenuBack;
			const targetElement = node.querySelector(
				`[data-mobile-menu-target="${target}"]`
			);
			targetElement.classList.remove('is-open');
			const trigger = node.querySelector(
				`[data-mobile-menu-trigger="${target}"]`
			);
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
		});
	});

	// Mobile sub-menu back buttons
	mobileSubMenuBackButtons.forEach(button => {
		button.addEventListener('click', e => {
			e.preventDefault();
			const target = button.dataset.mobileSubMenuBack;
			const targetElement = node.querySelector(
				`[data-mobile-sub-menu-target="${target}"]`
			);
			targetElement.classList.remove('is-open');
			const trigger = node.querySelector(
				`[data-mobile-sub-menu-trigger="${target}"]`
			);
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
		});
	});

	// Mobile menu close button
	if (mobileMenuCloseButton.length > 0) {
		mobileMenuCloseButton.forEach(button => {
			button.addEventListener('click', e => {
				e.preventDefault();
				nav.close();
			});
		});
	}

	// Headroom
	const headroom = new Headroom(node, {
		tolerance: {
			up: 5,
			down: 0,
		},
	});

	// Track sticky navbar state to control Headroom behavior
	// When sticky navbar is stuck at top, hide header and freeze until user scrolls back up
	const stickyNavbar = document.getElementById('sticky-navbar');
	let stickyObserver = null;
	let isNavbarStuck = false;

	let lastScrollY = window.scrollY;
	let scrollListener = null;
	let scrollRAFId = null;
	let isTransitioning = false;
	let menuIsOpen = false;

	if (stickyNavbar) {
		// Create a sentinel element to detect when sticky navbar becomes stuck
		const sentinel = document.createElement('div');
		sentinel.style.cssText =
			'position: absolute; height: 1px; width: 100%; pointer-events: none;';
		stickyNavbar.parentNode.insertBefore(sentinel, stickyNavbar);

		stickyObserver = new IntersectionObserver(
			([entry]) => {
				if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
					// Sentinel has scrolled above viewport - navbar is now stuck
					if (!isNavbarStuck) {
						isTransitioning = true;
						isNavbarStuck = true;
						headroom.unpin();
						headroom.freeze();
						stickyNavbar.style.top = '0px';
						setTimeout(() => {
							isTransitioning = false;
						}, 50);
					}
				} else {
					// Sentinel is visible - navbar back in natural position
					if (isNavbarStuck) {
						isTransitioning = true;
						isNavbarStuck = false;
						stickyNavbar.style.top = '';
						headroom.unfreeze();
						headroom.pin();
						setTimeout(() => {
							isTransitioning = false;
						}, 50);
					}
				}
			},
			{ threshold: 0 }
		);

		stickyObserver.observe(sentinel);

		// Scroll direction listener for header show/hide while sticky nav is stuck
		scrollListener = () => {
			if (scrollRAFId) cancelAnimationFrame(scrollRAFId);

			scrollRAFId = requestAnimationFrame(() => {
				const currentScrollY = window.scrollY;
				const scrollingUp = currentScrollY < lastScrollY;
				lastScrollY = currentScrollY;

				if (!isNavbarStuck || isTransitioning || menuIsOpen) return;

				const headerHeight = node.offsetHeight;

				if (scrollingUp) {
					headroom.unfreeze();
					headroom.pin();
					stickyNavbar.style.top = `${headerHeight}px`;
				} else {
					headroom.unpin();
					headroom.freeze();
					stickyNavbar.style.top = '0px';
				}
			});
		};

		window.addEventListener('scroll', scrollListener, { passive: true });
	}

	// Expose the live header height so in-page anchors can offset their scroll
	// position (see scroll-margin-top in objects/wysiwyg.css)
	const headerResizeObserver = new ResizeObserver(([entry]) => {
		const height = Math.round(entry.borderBoxSize[0].blockSize);
		document.documentElement.style.setProperty(
			'--header-height',
			`${height}px`
		);
	});
	headerResizeObserver.observe(node);

	eventBus.on('menu:open', () => {
		menuIsOpen = true;
		headroom.freeze();
	});
	eventBus.on('menu:close', () => {
		menuIsOpen = false;
		// Only unfreeze if navbar isn't stuck
		if (!isNavbarStuck) {
			headroom.unfreeze();
		}
	});

	let windowTop = 0;
	const lock = {
		capture() {
			windowTop = window.scrollY;
			document.body.style.position = 'fixed';
			document.body.style.top = `${windowTop * -1}px`;
			document.body.style.overflow = 'hidden';
			document.body.style.width = '100vw';
			headroom.freeze();
		},
		release() {
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.overflow = '';
			document.body.style.width = '';
			if (windowTop)
				window.scroll({ left: 0, top: windowTop, behavior: 'instant' });
			setTimeout(() => headroom.unfreeze(), 1);
		},
	};

	const nav = toggle({
		button: node.querySelector('.o-burger'),
		name,
		activeClass: 'is-active',
	});

	/*
	 *		Functions
	 */

	// function clickWhenOpenHandle({ target }) {
	// 	console.log('clickWhenOpenHandle');
	// 	if (target.id === 'header' || target.closest('#header')) return; // Continue if clicking within #Header
	// 	nav.close();
	// }

	nav.on(`open:${name}`, ({ target }) => {
		node.classList.add('menu-open');
		target.classList.add('is-open');

		const burger = node.querySelector('.o-burger');
		if (burger) burger.setAttribute('aria-expanded', 'true');

		eventBus.emit('menu:open');

		lock.capture();
	});

	nav.on(`close:${name}`, ({ target }) => {
		node.classList.remove('menu-open');
		target.classList.remove('is-open');

		const burger = node.querySelector('.o-burger');
		if (burger) burger.setAttribute('aria-expanded', 'false');

		// Close all nested mobile menus
		mobileMenuTargets.forEach(menu => {
			menu.classList.remove('is-open');
		});
		mobileSubMenuTargets.forEach(menu => {
			menu.classList.remove('is-open');
		});

		eventBus.emit('menu:close');

		lock.release();
	});

	eventBus.on('page:exited', nav.close);
	// Main Mobile Menu END

	function onKeyDown(event) {
		const { key } = event;
		if (key === 'Escape') {
			if (nav.isOpen) {
				nav.close();
			}
			menuTargets.forEach(t => {
				t.classList.remove('is-open');
			});
			menuTriggers.forEach(t => {
				const triggerBtn = t.querySelector(':scope > a, :scope > button');
				if (triggerBtn) {
					triggerBtn.setAttribute('aria-expanded', 'false');
				}
			});
		}
	}

	function onHasChildren() {
		$experienceMenuList.classList.add('translate-x-full');
		$holidayIdeasList.classList.add('translate-x-full');
	}

	function onNoChildren() {
		$experienceMenuList.classList.remove('translate-x-full');
		$holidayIdeasList.classList.remove('translate-x-full');
	}

	function onSearchFocus() {
		$headerSearchWrapper.classList.remove('hidden');

		const searchInput = $headerSearchWrapper.querySelector(
			'input[type="search"]'
		);
		searchInput.focus();
	}

	function onSearchClose() {
		$headerSearchWrapper.classList.add('hidden');
	}

	/*
	 *		Init
	 */
	nav.init();
	headroom.init();

	/*
	 *		Events
	 */

	addEvents(document.body, {
		keydown: onKeyDown,
	});

	addEvents({
		'click [data-search-control]': onSearchFocus,
		'mouseover [data-has-children]': onHasChildren,
		'mouseout [data-has-children]': onNoChildren,
		'click [data-search-close]': onSearchClose,
	});

	return () => {
		// Clean up eventBus listeners
		eventBus.off('menu:open');
		eventBus.off('menu:close');
		eventBus.off('page:exited');

		// Clean up scroll listener
		if (scrollListener) {
			window.removeEventListener('scroll', scrollListener);
		}
		if (scrollRAFId) {
			cancelAnimationFrame(scrollRAFId);
		}

		// Clean up sticky observer
		if (stickyObserver) {
			stickyObserver.disconnect();
		}

		headerResizeObserver.disconnect();

		// Clean up toggle
		nav.destroy();

		// Clean up headroom
		headroom.destroy();
		device.cancel();
	};
}

export default withPlugins(domEvents, device)(Header);
